export default "__VITE_ASSET__CGggSVi4__"